import React, { Component } from 'react';
//import {connect} from 'react-redux';

import './../../../scss/App.scss';
import AnswerField from './AnswerField';
import FormContainer from '../form/FormContainer';

import { trackingWrapper } from '../../utils/analytics';

class Step3 extends Component {

	constructor(props){
		super(props);

		this.key = this.props.answersKey; // keep track of key for answer line creation and removal

		this.state = {
			"categoryData": this.props.categoryData,
			"answers": [],
			"badWordAnswersIndex": [],
			"processing": false
		}

		this.handleGenerateBtn = this.handleGenerateBtn.bind(this);
		this.handleUpdateAnswer = this.handleUpdateAnswer.bind(this);
		this.addAnswer = this.addAnswer.bind(this);
		this.deleteAnswer = this.deleteAnswer.bind(this);
		this.handleDeleteBtn = this.handleDeleteBtn.bind(this);

	}

	componentDidMount(){
		//console.log("STEP 3 mounted");

		this.initAnswers();
		
		//this.animateIn();

		//window.sounds.introBg.play();

		/*
		let _this = this;

		setTimeout(() => {
			_this.props.handleIntroComplete();
		}, 3000);
		*/

	}

	animateIn(){
		/*
		window.TweenMax.set(this.refs.logo, {transform:"translateX(-10%)", opacity:0});
		window.TweenMax.to(this.refs.logo, 2.2, {ease:"expo.out", transform:"translateX(-50%)", opacity:1});

		window.TweenMax.set(this.refs.tagline, {transform:"translateX(-90%)", opacity:0});
		window.TweenMax.to(this.refs.tagline, 2.2, {ease:"expo.out", transform:"translateX(-50%)", opacity:1});

		window.TweenMax.set(this.refs.crosswordBg, {opacity:0});
		window.TweenMax.to(this.refs.crosswordBg, 2, {ease:"linear", opacity:1});
		window.TweenMax.to(this.refs.crosswordBg, 20, {top:"-16vw"});

		let _this = this;
		setTimeout(() => {
			_this.aniamteOut();
			_this.props.handleIntroInComplete()
		}, 4000);
		*/
	}

	aniamteOut(){
		/*
		let _this = this;

		window.TweenMax.to(this.refs.crosswordBg, .2, {opacity:0});
		window.TweenMax.to(this.refs.host, .2, {opacity:0});
		window.TweenMax.to(this.refs.tuneIn, .3, {opacity:0});
		window.TweenMax.to(this.refs.bg, 1, {opacity:0, onComplete:function(){
			_this.props.handleIntroOutComplete();
		}});

		window.TweenMax.to(this.refs.logo, .4, {opacity:0});
		window.TweenMax.to(this.refs.logo, .5, {ease:"expo.in", transform:"translateX(-150%)"});

		window.TweenMax.to(this.refs.tagline, .4, {opacity:0});
		window.TweenMax.to(this.refs.tagline, .5, {ease:"expo.in", transform:"translateX(50%)"});
		*/
	}

	initAnswers(){

		if(this.props.answers !== null){
			this.setState({
				"answers": this.props.answers
			});
		}
		else {
			const minAnswers = 3;

			let answers = [];

			for(let i = 0; i < minAnswers; i++){
				answers.push(this.createNewAnswerDataObj());
			}

			this.setState({
				"answers": answers
			});
		}
	}

	createNewAnswerDataObj(){
		let answerDataObj = {
			"key": this.key++,
			"value": ""
		}

		this.props.handleUpdateAnswersKey(this.key);

		return answerDataObj;
	}

	addAnswer(){
		let newAnswers = [...this.state.answers];

		newAnswers.push(this.createNewAnswerDataObj());

		this.setState({
			"answers": newAnswers
		});
	}

	deleteAnswer(key){
		const index = this.getIndexOfKey(key);
		
		let newAnswers = [...this.state.answers];

		newAnswers.splice(index, 1);

		this.setState({
			"answers": newAnswers,
			"badWordAnswersIndex": []
		});		

		this.props.handleUpdateAnswers(newAnswers);
	}

	getIndexOfKey(key){
		for(let i = 0; i < this.state.answers.length; i++){
			if(this.state.answers[i].key === key){
				return i;
			}
		}

		return -1;
	}

	handleGenerateBtn(){
		this.setState({
			"badWordAnswersIndex": []
		});

		//console.log("handleGenerateBtn answers:", this.state.answers);
		let validFieldCount = 0;
		let invalidFieldCount = 0;
		const agree = this.refs.agree.checked;

		// create array with only the values
		let filteredAnswers = [...this.state.answers.map((answer) => {
			return answer.value
		})];

		// remove empty strings
		filteredAnswers = filteredAnswers.filter(item => item);

		// check answers are at least 2 characters long
		for(let i = 0; i < filteredAnswers.length; i++){
			if(filteredAnswers[i].length >= 2){
				validFieldCount++;
			}
			else{
				if(filteredAnswers[i] !== ""){
					invalidFieldCount++;
				}
			}
		}
		
		//

		if(invalidFieldCount > 0){
			alert("Answers need to be a minimum of 2 characters long.");
		}
		else if(validFieldCount >= 3){
			// check for duplicate answers
			if(this.hasDuplicates(filteredAnswers)){
				alert("All answers must be unique. Please try a different answer.");
			}
			else {
				// test for bad words if useAPI mode is true
				if(window.app.configData.useAPI_badWords_creation){

					this.setState({
						"processing": true
					});
					
					const apiSource = window.app.configData.APIsource;
					const badwordAPI = window.app.configData[apiSource].badwordFilter;

					//

					console.log("this.state.answers", this.state.answers);
					console.log("JSON.stringify(data)", JSON.stringify({"data":this.state.answers}));

					//
					
					fetch(badwordAPI, {
						method: 'POST',
						body: JSON.stringify({
							"type": "json",
							"data": this.state.answers
						}),
					})
					.then((response) => response.json())
					.then((data) => {
						console.log('badword api Success:', data);

						// if bad words found, show error
						if(data.badWords.length > 0){
							let badWordArr = [];

							for(let i = 0; i < data.badWords.length; i++){
								//badWordArr[parseInt(data.badWords[i])] = true;
								badWordArr.push(data.badWords[i]);
							}
							
							this.setState({
								"badWordAnswersIndex": badWordArr,
								"processing": false
							});
							
							alert("Inappropriate language was found. Please try other words.");
						}
						else {
							// else submit to creation api
							this.props.handleSnapshot(this.state.answers);

							setTimeout(() => {
								this.submitCreation();
							}, 10);
						}
					})
					.catch((error) => {
						
						console.error('badword api Error:', error);
						alert("Something went wrong. Please try again later.");

						this.setState({
							"processing": false
						});
						
					});
					
				}
				else {
					this.setState({
						"processing": true
					});

					// send answers up to render snapshot layer
					this.props.handleSnapshot(this.state.answers);

					// wait a little for snapshot layer to render
					setTimeout(() => {
						this.submitCreation();
					}, 10);
				}
			}
		}
		else {
			alert("Please fill-out at least 3 answers.");
		}
	}

	submitCreation(){
		if(window.app.configData.useAPI_creation){
			const apiSource = window.app.configData.APIsource;
			const creationAPI = window.app.configData[apiSource].creation;

			// generate img data
			window.html2canvas(document.querySelector("#snapshotLayer"),{
				scale:1,
				width:1200,
				height: 630,
				windowHeight: window.outerHeight + window.innerHeight,
				scrollY: -window.scrollY,
				scrollX: -window.scrollX
		   }).then(canvas => {
				window.$("#hiddenCanvas").empty();
				window.$("#hiddenCanvas").append(canvas);
	
				 // take snapshot of canvas
				 let canvasImage = window.$("#hiddenCanvas > canvas").get(0).toDataURL("image/jpeg", 1);
	
				 //console.log("canvasImage", canvasImage);

				 let data = {
					"questionID": this.props.questionID,
					"question": this.props.question,
					"gameData": this.state.answers, 
					"shareImg": canvasImage, 
					"firstName": this.props.firstName,
					"email": this.props.email,
					"displayName": this.props.displayName,
					"authorizeShare": this.props.authorizeShareChecked
				}

				console.log("creation data", data);
				console.log("creation data JSON.stringify", JSON.stringify(data));
	
				fetch(creationAPI, {
					method: 'POST',
					body: JSON.stringify(data),
				})
				.then((response) => response.json())
				.then((data) => {
					console.log('creation api Success:', data);
	
					if(data.success){
						const public_id = data.public_id;
						const shareURL = data.share_url;
						console.log("public_id", public_id);
	
						//
	
						this.setState({
							"processing": false
						});

						//

						// tracking
						trackingWrapper('event', 'ASDIY-game-board-create', {'event_category':'america-says-diy'});
						
						// detect nsfw content
						if(data.nswf.output.nsfw_score > 0.003){
							// alert error and return to pre-submit state
							alert("Inappropriate content detected. (Error code: 733)");
						}
						else{
							// update vars and continue process
							this.props.handleAnswersCompleted(public_id, shareURL);
						}
					}
					else {
						alert("Something went wrong. Please try again later.");
	
						this.setState({
							"processing": false
						});
					}
				})
				.catch((error) => {
					
					console.error('creation api Error:', error);
					alert("Something went wrong. Please try again later.");
	
					this.setState({
						"processing": false
					});
					
				});

			});
		}
		else {
			this.props.handleAnswersCompleted();
		}
	}

	hasDuplicates(arr) {
		return new Set(arr).size !== arr.length;
	}

	handleDeleteBtn(key){
		this.deleteAnswer(key);
	}

	handleUpdateAnswer(key, value){
		let newAnswers = [...this.state.answers];
		let index = this.getIndexOfKey(key);

		newAnswers[index].value = value;

		this.setState({
			"answers": newAnswers
		});

		this.props.handleUpdateAnswers(newAnswers);
	}

	renderAnswerFields(){
		return (
			<div className="answerFields">
				{this.state.answers.map((answer, index) => {
					let showDelete = true;

					if(this.state.answers.length <= 3){
						showDelete = false;
					}

					//

					let badWordFound = false;

					if(this.keyHasBadword(answer.key)){
						badWordFound = true;
					}

					return (
						<AnswerField number={index + 1} key={answer.key} handleUpdateAnswer={this.handleUpdateAnswer} answerObj={answer} showDelete={showDelete} handleDeleteBtn={this.handleDeleteBtn} badWordFound={badWordFound}  />
					)
				})}
			</div>
		)
	}

	keyHasBadword(key){
		for(let i = 0; i < this.state.badWordAnswersIndex.length; i++){
			if(this.state.badWordAnswersIndex[i] === key){
				return true;
			}
		}

		return false;
	}

	renderAddBtn(){
		if(this.state.answers.length < 7){
			return(
				<div className="addBtn" onClick={this.addAnswer}>+ Add Another Answer</div>
			)
		}
	}

	renderSubmitBtn(){
		let processing = "";

		if(this.state.processing){
			processing = "processing";
		}

		return(
			<div className={"generateBtn " + processing} onClick={() => this.handleGenerateBtn()}>
				<div className="label">Generate My Game!</div>
				<div className="spinner fas fa-spinner fa-pulse"></div>
			</div>
		);
	}

	render() {

		return (
			<div id="step3">
				<div className="heading">Step 3: Type in Your Answers</div>
				<div className="question">{this.props.question}</div>
				{this.renderAnswerFields()}
				{this.renderAddBtn()}
				<div className="submit_wrapper">
					<div className="legal"><input type="checkbox" ref="agree" checked={this.props.authorizeShareChecked} onChange={() => this.props.handleShareAuthorizationChecked(this.refs.agree.checked)} />I authorize Game Show Network to use this content publicly.</div>
					{this.renderSubmitBtn()}
				</div>
			</div>
		);
	}
}

export default Step3;


// WEBPACK FOOTER //
// ./src/js/components/generator/Step3.js